/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BrandResponse
 */
export interface BrandResponse {
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    effective?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    enabled?: boolean;
}

export function BrandResponseFromJSON(json: any): BrandResponse {
    return BrandResponseFromJSONTyped(json, false);
}

export function BrandResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'effective': !exists(json, 'effective') ? undefined : json['effective'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function BrandResponseToJSON(value?: BrandResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'deleted': value.deleted,
        'effective': value.effective,
        'enabled': value.enabled,
    };
}


